import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Alusta toote valimist ruumi järgi

  <span style="color:#85c1dc;">**FI:**</span>
  Tutustu huoneisiin

  <span style="color:#85c1dc;">**RU:**</span>
  Начать поиск по комнате
*/
/* @__NO_SIDE_EFFECTS__ */
const m294 = msg(
  mf`Alusta toote valimist ruumi järgi`,
  mf`Tutustu huoneisiin`,
  mf`Начать поиск по комнате`,
)

export { m294 as 'w.module.room_categories.title' }